<template>
  <div>
    <div class="topBack">
      <i class="iconfont iconback" @click="onTopBack" />
    </div>
    <img src="/img/hbup.jpg" class="back">
    <div class="downRect">
      <img src="/img/hbdown.jpg" class="back">
      <div class="Body">
        <div class="title">
          活动二<br>
          <span style="color:#0092FA">认证成为SSI的潜水员<br>免费抽取价值188元Adex纪念卡！</span>
        </div>
        1.参与条件：除SSI体系外，其他潜水组织的潜水员<br>
        2.参与方式：交叉认证SSI潜水证后参与抽奖，获取抽奖码，共抽出240个潜水员送出个人专属<span style="font-weight: 700;">价值188元的Adex纪念卡</span><br>
        3.抽奖规则：分别在7月6日、7日、13日、14日的12点至17点，每小时整点抽出10个中奖名额，每天抽出60个中奖名额，四天一共产生240个中奖名额。<br>
        <div class="title">活动说明</div>
        1.每人交叉认证的次数不限，仅限参与一次抽奖活动<br>
        2.中奖名额会有公众号推送通知<br>
        3.中奖的潜水卡采取邮寄的方式，在提交申请后30天内发出<br>
        4.需要交叉认证卡片成功后才可领取奖品<br>
        <div class="emptyRect" />
      </div>
    </div>
    <div class="downButton">
      <van-button type="info" square @click="onActivity" disabled>立刻参加,免费抽取<span style="font-weight: 700;">价值188元的Adex纪念卡[已结束]</span></van-button>
    </div>
  </div>
</template>
<script>
// import request from '@/utils/request'
import { getUrlKey } from '@/utils/base'
import { Button } from 'vant'
export default {
  components: {
    [Button.name]: Button

  },
  data() {
    return {
    }
  },
  mounted() {
    console.log('进入')
    document.getElementsByTagName('body')[0].className = 'activeBacl'
  },
  destroyed: function() {
    console.log('离开')
    document.body.removeAttribute('class', 'activeBacl')
  },
  created() {
    var url = getUrlKey('backurl')
    if (url !== null) {
      this.backurl = url
    }
  },
  methods: {
    onTopBack() {
      this.$router.replace('/home/index')
    },
    onActivity() {
      this.$router.replace('/activity/raffleReg')
    }
  }
}
</script>
<style scoped>
.topBack{
   z-index: 100;
  position: absolute;
  left:1em;
  top: 1em;
  color: #fff;
}

.back{
  width: 100%;
  margin: 0;
  padding: 0;
  vertical-align:top;
}
.downRect{
  position: relative;
}
.Body{
  padding: 0 2em;
  margin-top: 4em;
  color: #fff;
  position: absolute;;
  left: 0;
  right: 0;
  top:0;
  line-height: 1.5em;
  font-size: 0.9em;
}
.title{
  font-size: 1.1em;
  font-weight: 700;
  margin: 2em 0 1em 0;
}
.emptyRect{
  height: 5em;
}
.downButton{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 42px;
}
.downButton button{
  background-color: #0092FA;
  border: #0092FA;
  width: 100%;
}
</style>
